export const config = JSON.parse(
  document.getElementById('landing-config').textContent
);
export const planKeys = [...Object.keys(config.plans), 'enterprise', 'unsure'];
export const calculatorPlans = ['start', 'growth', 'pro'];
export const channels = [
  { id: 'telegram', image: '/static/v2/icons/telegram.svg' },
  { id: 'whatsapp', image: '/assets/images/dashboard/channels/whatsapp.png' },
  { id: 'eitaa', image: '/static/v2/icons/eitaa_logo.svg' },
  { id: 'bale', image: '/static/v2/icons/bale.png' },
  { id: 'rubika', image: '/static/v2/icons/rubika.png' },
  { id: 'soroushplus', image: '/static/v2/icons/splus.svg' },
  { id: 'instagram', image: '/assets/images/dashboard/channels/instagram.png' },
];
export const number = value => new Intl.NumberFormat('fa-IR').format(value);
export const toEnglishDigits = value =>
  String(value ?? '')
    .replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
    .replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit));
export const integer = value => {
  const parsed = Number.parseInt(toEnglishDigits(value), 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};
export const decimal = value => {
  const parsed = Number(toEnglishDigits(value));
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};
export const calculatePrice = (plan, users, accounts, messages, storage) => {
  const base = config.plans[plan];
  if (!base) return null;
  const extraUsers = Math.max(users - base.users, 0);
  const extraAccounts = Math.max(accounts - base.accounts, 0);
  const extraStorage = Math.max(storage - base.storage, 0);
  const extraStorageCost =
    config.extra_storage_per_gb_monthly == null
      ? null
      : extraStorage * config.extra_storage_per_gb_monthly;
  const totalWithoutStorage =
    base.price +
    extraUsers * config.extra_user_price +
    extraAccounts * config.extra_account_price +
    messages * config.sent_message_price;
  return {
    basePrice: base.price,
    extraUsers,
    extraUsersCost: extraUsers * config.extra_user_price,
    extraAccounts,
    extraAccountsCost: extraAccounts * config.extra_account_price,
    messagesCost: messages * config.sent_message_price,
    extraStorage,
    extraStorageCost,
    storageInquiry: extraStorage > 0 && extraStorageCost == null,
    totalWithoutStorage,
    total:
      extraStorage > 0 && extraStorageCost == null
        ? null
        : totalWithoutStorage + (extraStorageCost ?? 0),
  };
};
export const priceFor = (plan, users, accounts, messages, storage) => {
  const base = config.plans[plan];
  return calculatePrice(
    plan,
    users,
    accounts ?? base?.accounts ?? 0,
    messages ?? 0,
    storage ?? base?.storage ?? 0
  )?.total;
};
export const normalizePhone = value => {
  const digits = toEnglishDigits(value);
  return digits.replace(/^(?:0098|0)/, '+98');
};
